/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CustomerExternalNumber } from '../../models/customer-external-number';

export interface FindAll6$Params {
  page?: number;
  count?: number;
  sort?: string;
  dir?: 'ASC' | 'DESC';
  status?: 'ACTIVE' | 'INACTIVE';
}

export function findAll6(http: HttpClient, rootUrl: string, params?: FindAll6$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<CustomerExternalNumber>>> {
  const rb = new RequestBuilder(rootUrl, findAll6.PATH, 'get');
  if (params) {
    rb.query('page', params.page, {});
    rb.query('count', params.count, {});
    rb.query('sort', params.sort, {});
    rb.query('dir', params.dir, {});
    rb.query('status', params.status, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<CustomerExternalNumber>>;
    })
  );
}

findAll6.PATH = '/api/values/customer-external-number';
